import { Badge } from "@dropbox/dig-components/badge";
import { Chip } from "@dropbox/dig-components/chip";
import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine } from "@dropbox/dig-icons/assets";
import useConnectors from "@mirage/service-connectors/useConnectors";
import { type ConnectorName } from "@mirage/shared/connectors";
import { ConnectorIcon } from "@mirage/shared/icons";
import { memo } from "react";
import styles from "./FilterChip.module.css";

const MAX_DISPLAYED_ICONS = 2;

interface FilterChipProps {
  selectedAppTypes: Set<string>;
  onDeselectAll: () => void;
}

export const FilterChip = memo(
  ({ selectedAppTypes, onDeselectAll }: FilterChipProps) => {
    const { connectors } = useConnectors();

    if (selectedAppTypes.size === 0) {
      return null;
    }

    return (
      <div className={styles.container}>
        <Chip isSelected selectedStyle="stroke" onClick={onDeselectAll}>
          <Chip.Content>
            <div className={styles.iconContainer}>
              {Array.from(selectedAppTypes)
                .slice(0, MAX_DISPLAYED_ICONS)
                .map((appType) => {
                  const connector = connectors.find(
                    (c) => c.id_attrs?.type === appType,
                  );
                  return (
                    <ConnectorIcon
                      key={appType}
                      connectorName={appType as ConnectorName}
                      iconUrl={connector?.branding?.icon_src}
                      size={18}
                    />
                  );
                })}
              {selectedAppTypes.size > MAX_DISPLAYED_ICONS && (
                <Badge>+ {selectedAppTypes.size - MAX_DISPLAYED_ICONS}</Badge>
              )}
            </div>
          </Chip.Content>
          <Chip.IconAccessory>
            <div className={styles.closeButton}>
              <UIIcon src={CloseLine} />
            </div>
          </Chip.IconAccessory>
        </Chip>
      </div>
    );
  },
);

FilterChip.displayName = "FilterChip";
